export default class TicketGroup {
    id!: number;
    desc1!: string;
    desc2!: number;
    ours!: boolean;
    retail_Price!:number;
    options!:number[];
    prices !: number[];
}
